import React from 'react';
import FundingCommissionStatusBadge from './FundingCommissionStatusBadge';

const formatCurrency = (value) => {
  if (value == null || value === '') return '—';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
};

const DetailRow = ({ label, value }) => (
  <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2.5">
    <div className="text-[11px] font-semibold uppercase tracking-wide text-[var(--fg-muted)]">{label}</div>
    <div className="mt-1 text-sm text-[var(--fg-text)]">{value || '—'}</div>
  </div>
);

const FundingCommissionDetail = ({ commission, onClose, onStatusChange, saving }) => {
  if (!commission) return null;

  const isPaid = commission.status === 'Paid';

  return (
    <div className="space-y-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-lg font-semibold text-[var(--fg-text)]">{commission.lenderName}</div>
          <div className="text-sm text-[var(--fg-muted)]">
            {commission.clientName} · {commission.businessName || '—'}
          </div>
        </div>
        <FundingCommissionStatusBadge status={commission.status} />
      </div>

      {!isPaid ? (
        <div className="rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800 dark:border-amber-900/40 dark:bg-amber-950/30 dark:text-amber-200">
          Commission is not guaranteed until status is Paid.
        </div>
      ) : null}

      <div className="grid gap-3 sm:grid-cols-2">
        <DetailRow label="Deal" value={commission.dealId} />
        <DetailRow label="Product" value={commission.productType} />
        <DetailRow label="Funded amount" value={formatCurrency(commission.fundedAmount)} />
        <DetailRow label="Commission amount" value={formatCurrency(commission.commissionAmount)} />
        <DetailRow label="Commission type" value={commission.commissionType} />
        <DetailRow label="Commission rate" value={commission.commissionRate != null ? String(commission.commissionRate) : '—'} />
        <DetailRow label="Payout status" value={commission.payoutStatus} />
        <DetailRow label="Payout due" value={commission.payoutDueAt} />
        <DetailRow label="Paid at" value={commission.paidAt} />
        <DetailRow label="Clawback risk" value={commission.clawbackRisk} />
        <DetailRow label="Clawback status" value={commission.clawbackStatus} />
        <DetailRow label="Clawback until" value={commission.clawbackUntil} />
        <DetailRow label="Reversed amount" value={formatCurrency(commission.reversedAmount)} />
      </div>

      {commission.notes ? <DetailRow label="Notes" value={commission.notes} /> : null}

      {onStatusChange ? (
        <div className="flex flex-wrap gap-2">
          {['Earned', 'Pending Payout', 'Paid', 'Clawback Risk', 'Reversed'].map((status) => (
            <button
              key={status}
              type="button"
              disabled={saving || commission.status === status}
              onClick={() => onStatusChange(commission, status)}
              className="rounded-xl border border-[var(--fg-line)] px-3 py-1.5 text-xs text-[var(--fg-muted)] hover:bg-[var(--fg-panel-soft)] disabled:opacity-40"
            >
              Mark {status}
            </button>
          ))}
        </div>
      ) : null}

      {onClose ? (
        <button type="button" onClick={onClose} className="rounded-xl border border-[var(--fg-line)] px-4 py-2 text-sm text-[var(--fg-muted)]">
          Close
        </button>
      ) : null}
    </div>
  );
};

export default FundingCommissionDetail;
